import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { defer as observableDefer, Subscribable } from 'rxjs';
import jsreport from 'jsreport-browser-client-dist';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx'; 

import { Constants } from '../core/constants';
import { ContextService } from '../core/context.service';
import { ConfigurationService } from '../core/configuration.service';
import { DatePipe } from '@angular/common';

const recipeMap = {
  'html': 'html',
  'pdf': 'phantom-pdf',
  'xlsx': 'html-to-xlsx'
};

@Component({
  selector: 'tv-report-actions',
  templateUrl: './report.actions.component.html',
  styleUrls: [
    './report.actions.component.css'
  ]
})
export class ReportActionsComponent implements OnInit {
  @Input()
  public templateName: string;

  @Input()
  public validateParameters: () => any;

  isViewEnabled = false;
  isDownloadAsExcelEnabled = false;
  isDownloadAsPdfEnabled = false;
  fileName= 'ExcelSheet.xlsx';  

  constructor(private route: ActivatedRoute,
    private constants: Constants,
    private contextService: ContextService,
    private configurationService: ConfigurationService,
    public datepipe: DatePipe) {
  }

  ngOnInit() {
    console.log('Report Actions route snap shot ', this.route.snapshot);

    const screen = this.route.snapshot.data['screen'];
    this.isViewEnabled = this.contextService.hasActionPermission(screen, this.constants.ScreenAction.Create)
      || this.contextService.hasActionPermission(screen, this.constants.ScreenAction.Update);
    this.isDownloadAsExcelEnabled = this.isViewEnabled;
    this.isDownloadAsPdfEnabled = this.isViewEnabled;
    console.log('Flags id ', this.isViewEnabled, this.isDownloadAsExcelEnabled, this.isDownloadAsPdfEnabled);
  }

  private validate(): any {
    if (this.validateParameters !== null) {
      return this.validateParameters();
    }

    return null;
  }

  view() {
    try {
      document.getElementById('reportMessage').innerText = '';
      const parameters = this.validate();
      if (parameters === null) return;

      this.isViewEnabled = false;

      this.viewJsReport(parameters)
        .subscribe(response => {
          const frameContent = `
          <html>
            <head></head>
            <body>
              ${response.toString()}
            </body>
          </html>`;
          document.getElementById('reportprintMessage').innerHTML = frameContent;
       //   const resultsFrame = document.getElementById('reportResult') as HTMLIFrameElement;
         /* resultsFrame.contentWindow.document.open();
          resultsFrame.contentWindow.document.write(frameContent);
          resultsFrame.contentWindow.document.close();*/
        },
        error => {
          document.getElementById('reportMessage').innerText = error;
        });

      this.isViewEnabled = true;
    } catch (error) {
      this.isViewEnabled = true;
      console.log('Error in reports view action.', error);
    }
  }


//   downloadAsExcel()
//   {
//     /* table id is passed over here */   
//     let element = document.getElementById('excel-table'); 
//     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

//     /* generate workbook and add the worksheet */
//     const wb: XLSX.WorkBook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

//     /* save to file */
//     XLSX.writeFile(wb, this.fileName);
   
//  }
downloadAsExcel()
{
  var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
      tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';
      tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
      tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
      tab_text = tab_text + "<table border='1px'>";
 
   
      tab_text = tab_text + document.getElementById("dvContainer").innerHTML; //$('#dvContainer1').html();
      tab_text = tab_text + '</table></body></html>';
      var data_type = 'data:application/vnd.ms-excel';
      var ua = window.navigator.userAgent;
     
          window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));
      
}
/*  downloadAsExcel() {
    try {
      document.getElementById('reportMessage').innerText = '';
      const parameters = this.validate();
      if (parameters === null) return;

      this.isDownloadAsExcelEnabled = false;

      this.downloadJsReport(parameters, 'xlsx')
        .then(function (result) {
          if (result.success === true) {
            document.getElementById('reportMessage').innerText = result.message;
          } else {
            document.getElementById('reportMessage').innerText = result.reason;
          }
        }, function (errorResult) {
          document.getElementById('reportMessage').innerText = errorResult.reason;
        });

      this.isDownloadAsExcelEnabled = true;
    } catch (error) {
      this.isDownloadAsExcelEnabled = true;
      console.log('Error in reports download excel action.', error);
    }
  }
*/
  public downloadAsPdf(): void {
    let DATA: any = document.getElementById('reportprintMessage');
    html2canvas(DATA).then((canvas) => {
    //  let fileWidth = 208;
     
      //let fileHeight = (canvas.height * fileWidth) / canvas.width;
      //let fileHeight = (canvas.height * fileWidth) / canvas.width;
      //const FILEURI = canvas.toDataURL('image/png');
      //console.log('fileHeight',fileHeight);
      //console.log('canvas.height',canvas.height);
      //let PDF = new jsPDF('p', 'mm', 'a4',true);
      //let position = 0;
      //PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight/2,'','FAST');
      //PDF.save('report download.pdf');


      var imgData = canvas.toDataURL('image/png');

      /*
      Here are the numbers (paper width and height) that I found to work. 
      It still creates a little overlap part between the pages, but good enough for me.
      if you can find an official number from jsPDF, use them.
      */
      var imgWidth = 210; 
      var pageHeight = 295;  
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      var doc = new jsPDF('p', 'mm');
      var position = 0;

      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save('file.pdf');
   
    });
  }


 /* downloadAsPdf() {
    try {
      document.getElementById('reportMessage').innerText = '';
      const parameters = this.validate();
      if (parameters === null) return;

      this.isDownloadAsPdfEnabled = false;

      this.downloadJsReport(parameters, 'pdf')
        .then(function (result) {
          if (result.success === true) {
            document.getElementById('reportMessage').innerText = result.message;
          } else {
            document.getElementById('reportMessage').innerText = result.reason;
          }
        }, function (errorResult) {
          document.getElementById('reportMessage').innerText = errorResult.reason;
        });

      this.isDownloadAsPdfEnabled = true;
    } catch (error) {
      this.isDownloadAsPdfEnabled = true;
      console.log('Error in reports download pdf action.', error);
    }
  }*/

  private getReportFileName(reportName: string, reportFormat: string, now: Date): string {
    return reportName + '_' + now.getFullYear() + '_' + (now.getMonth() + 1) + '_' + now.getMonth()
      + '_' + now.getHours() + '_' + now.getMinutes() + '_' + now.getSeconds() + '.' + reportFormat;
  }

  private getUserDetails(now: Date): any {
    const user = this.contextService.user;
   
    const currentBranch = this.contextService.currentBranch;
    return {
      generatedById: user.id,
      generatedByName: user.userName,
      generatedDate: this.datepipe.transform((new Date), 'yyyy-MM-dd h:mm:ss'),
      currentBranchId: currentBranch.id,
      branchId: user.currentBranch.id,
      bankId: user.bankId,
      bankName: user.bankName,
      branchName: user.currentBranch.name
    };
   
  }

  private prepareJsReportRequest(reportFormat: string, reportParameters: any, options: any): any {
    const jwt = '';

    jsreport.serverUrl = this.configurationService.ReportApiUrl;
    jsreport.headers = {
      Authorization: `Bearer ${jwt}`
    };

    const request = {
      template: {
        name: this.templateName,
        recipe: recipeMap[reportFormat]
      },
      data: {
        parameters: reportParameters
      },
      options
    };

    return request;
  }

  private viewJsReport(parameters: any): Subscribable<any> {
    const now = new Date();
    const renderOptions = {};

    const reportParameters = Object.assign({}, parameters, this.getUserDetails(now));

    const options = Object.assign({ timeout: 60000 }, renderOptions);
    const request = this.prepareJsReportRequest('html', reportParameters, options);

    return observableDefer(() => jsreport.renderAsync(request));
  }

  private downloadJsReport(parameters: any, reportFormat: string): Promise<any> {
    const now = new Date();
    const reportFileName = this.getReportFileName(this.templateName, reportFormat, now);

    const reportParameters = Object.assign({}, parameters, this.getUserDetails(now));

    const renderOptions = {
      "Content-Disposition": "attachment;filename=" + reportFileName
    };

    const options = Object.assign({ timeout: 60000 }, renderOptions);
    const request = this.prepareJsReportRequest(reportFormat, reportParameters, options);

    return new Promise<any>((resolve, reject) => {
      jsreport.renderAsync(request).then(function (response) {
        response.download(reportFileName);
        resolve({ reason: '', success: true, message: 'Report generated successfully.' });
      }, function (exception) {
        console.log('Failed with error', exception);
        let reason = exception?.error?.message;
        if (reason === null || reason === undefined) {
          reason = exception;
        }
        reject({ reason, success: false });
      });
    });
  }

  /* private saveJsReport(templateName, parameters, reportFormat) {
    const now = new Date();
    const reportFileName = this.getReportFileName(templateName, reportFormat, now);

    const renderOptions = {
      reportName: reportFileName,
      reports: {
        save: true
      }
    };
    const reportParameters = Object.assign({}, parameters, this.getUserDetails(now));

    const options = Object.assign({ timeout: 60000 }, renderOptions);
    const request = prepareJsReportRequest(templateName, reportFormat, reportParameters, options);

    return Q.Promise((resolve, reject, notify) => {
      jsreport.renderAsync(request).then(function (response) {
        console.log('Response', response);
        console.log('Headers', response.xhr.getResponseHeader('Content-Type'),
          response.xhr.getResponseHeader('Permanent-Link'));
        resolve({ reason: '', success: true, message: 'Report saved successfully.' });
      }, function (exception) {
        console.log('Failed with error', exception);
        reject({ reason: exception, success: false });
      });
    });
  } */
}
